import React from "react";
import { BsPatchCheckFill } from "react-icons/bs";
import "./Experience.css";

const SkillItem = ({ name, level }) => {
  return (
    <article className="experience__details">
      <BsPatchCheckFill className="experience__details-icon" />
      <div>
        <h4 className="skill__name">{name}</h4>
        {/* <small className="text-light">{level}</small> */}
      </div>
    </article>
  );
};

export default SkillItem;
